import Ajax from '../../assets/js/Ajax'

export default {
    namespaced: true,
    state: () => ({
        search_conditions: [],
        selected_room_info: null,
        search_text: '',
    }),
    mutations: {
        async setSearchConditions(state, tags) {
            state.search_conditions = tags;
        },
        setSelectedRoomInfo(state, info) {
            state.selected_room_info = info;
        },
        updateSearchText(state, text) {
            state.search_text = text;
        },
    },
    actions: {

    },
    getters: {

    },

}
